import React from 'react';

import { useHistory } from 'react-router-dom';
import opcLogo from 'styles/assets/svg/opc-logo.svg';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { settingsConfig } from 'components/Settings/settingsConfig';
import { IntegrationCard } from 'components/pages/IntegrationsPage/components/Integrations/components/AvailableIntegrations/components/IntegrationCard/IntegrationCard';

import classes from './AvailableIntegrations.module.scss';

export const AvailableIntegrations = () => {
    const history = useHistory();

    const onConnect = (): void => {
        history.push(
            AppRoutes.buildPath(
                AppRoutes.SETTINGS,
                settingsConfig.integrations.link,
                settingsConfig.opc.link,
                settingsConfig.createOpc.link,
            ),
        );
    };

    return (
        <div className={classes.AvailableIntegrations}>
            <div className={classes.title}>Available Integrations</div>
            <div className={classes.cardsContainer}>
                <IntegrationCard
                    image={opcLogo}
                    title={'Oracle Primavera Cloud'}
                    subtitle={'Import and export schedules directly with Oracle Primavera Cloud.'}
                    onConnect={onConnect}
                />
            </div>
        </div>
    );
};
